import { render, staticRenderFns } from "./dtp-query-site-card.vue?vue&type=template&id=f569e20e&scoped=true"
import script from "./dtp-query-site-card.vue?vue&type=script&lang=js"
export * from "./dtp-query-site-card.vue?vue&type=script&lang=js"
import style0 from "./dtp-query-site-card.vue?vue&type=style&index=0&id=f569e20e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f569e20e",
  null
  
)

export default component.exports